import { Effect } from 'effect';

/**
 * Bridges the React/Auth0 world to the Effect transport layer.
 *
 * Auth0 lives in React state; the Effect `HttpClient` runs inside the Atom
 * runtime. Rather than threading a token through every Effect, the app
 * registers a getter here once (after login) and the authenticated client
 * reads the current token per request. Returns `null` when unauthenticated
 * (e.g. local dev), so requests simply go out without an Authorization header.
 */
let tokenGetter: (() => Promise<string>) | null = null;

export function setBearerTokenGetter(getter: (() => Promise<string>) | null): void {
  tokenGetter = getter;
}

export const currentBearerToken: Effect.Effect<string | null> = Effect.promise(async () => {
  if (!tokenGetter) return null;
  try {
    return await tokenGetter();
  } catch {
    return null;
  }
});
